var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionGreenbg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 727 \\u2013 20",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9049",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.977 10.033A9.988 9.988 0 1 1 9.988 0a10.01 10.01 0 0 1 9.989 10.033z",
    transform: "translate(2.031 1.98)",
    style: {
      fill: "#e9fcf4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon open-question-mark",
    d: "M3.071 0A2.988 2.988 0 0 1 5.38.905a3.163 3.163 0 0 1 .72 1.756l-1.228.178a1.758 1.758 0 0 0-.372-.946 1.718 1.718 0 0 0-1.425-.521 2.016 2.016 0 0 0-1.5.466 1.214 1.214 0 0 0-.344.905A2.378 2.378 0 0 0 2.26 4.8a4.049 4.049 0 0 1 1.425 3.086v.343H2.457v-.343a2.353 2.353 0 0 0-.995-2.057A4.064 4.064 0 0 1 0 2.743 2.8 2.8 0 0 1 .725.809 3.167 3.167 0 0 1 3.071 0zm.614 9.6v1.371H2.457V9.6z",
    transform: "translate(9.37 6.935)",
    style: {
      fill: "#1bc47d"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionGreenbg);
export default __webpack_public_path__ + "static/media/question-greenbg.55eaa7ce9d75373ebd6a32267e663f09.svg";
export { ForwardRef as ReactComponent };